var _g, _g2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavXpentraLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 24.854,
    viewBox: "0 0 130 24.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(44.831 4.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M508.313,506.38a11.824,11.824,0,0,0-4.2.629,1.082,1.082,0,0,0-.846,1.239v13.825c0,.5.152.674.652.674h1.192c.5,0,.674-.174.674-.674V517.9a8.423,8.423,0,0,0,2.261.393c3.282,0,4.847-1.631,4.847-4.543v-2.98C512.9,507.987,511.466,506.38,508.313,506.38Zm2.066,7.281c0,1.564-.784,2.327-2.5,2.327a8.077,8.077,0,0,1-2.088-.328V509.2c0-.151.021-.217.195-.281a7.226,7.226,0,0,1,1.979-.243c1.565,0,2.414.74,2.414,2.152Z",
    transform: "translate(-487.245 -502.531)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M612.354,513.126c.739,0,.978-.371.978-.938v-1.319c0-2.5-1.586-4.5-5.041-4.5-3.282,0-5.041,1.673-5.041,4.689v2.571c0,2.674,1.435,4.653,5,4.653,2.478,0,3.912-.805,4.7-2.088.3-.478.234-.848-.261-1.087l-.761-.413c-.522-.283-.761-.218-1.087.26a2.858,2.858,0,0,1-2.565,1.152c-1.61,0-2.5-.761-2.5-2.173v-.809Zm-6.586-2.413c0-1.413.89-2.218,2.521-2.218,1.653,0,2.522.805,2.522,2.218v.478H605.77Z",
    transform: "translate(-575.505 -502.523)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M713.819,506.37a11.192,11.192,0,0,0-4.281.738,1.084,1.084,0,0,0-.828,1.239v8.935c0,.5.152.673.652.673h1.2c.5,0,.674-.173.674-.673v-8.109a.235.235,0,0,1,.131-.217,7.916,7.916,0,0,1,2.087-.284c1.608,0,2.369.7,2.369,2.131v6.478c0,.5.174.673.674.673h1.172c.5,0,.674-.173.674-.673v-6.544C718.34,507.978,716.928,506.37,713.819,506.37Z",
    transform: "translate(-668.602 -502.523)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M811.194,491.835c.5,0,.652-.173.652-.674v-1c0-.5-.151-.652-.652-.652h-2.5v-1.958c0-.5-.152-.652-.652-.652h-1.2c-.5,0-.674.152-.674.652v1.957h-1.478c-.5,0-.674.151-.674.652v1c0,.5.173.674.674.674h1.478v4.13c0,3.761,1.326,4.806,5,4.806.5,0,.673-.194.673-.7v-1.022c0-.5-.174-.673-.673-.673-1.826,0-2.478-.37-2.478-2.5v-4.044Z",
    transform: "translate(-752.739 -485.335)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M893.229,509.15h-.718a11.375,11.375,0,0,0-4.043.652,1.063,1.063,0,0,0-.828,1.217v8.718c0,.5.154.673.653.673h1.2c.5,0,.674-.174.674-.673v-7.76a.253.253,0,0,1,.2-.284,7.805,7.805,0,0,1,2.086-.26h.784c.5,0,.652-.152.652-.652V509.8C893.88,509.3,893.728,509.15,893.229,509.15Z",
    transform: "translate(-826.556 -504.977)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M954.291,506.37c-2.284,0-3.762.847-4.523,2.26-.26.5-.108.762.37.979l.891.352c.478.195.608.13.913-.327a2.524,2.524,0,0,1,2.282-1.043c1.652,0,2.173.805,2.173,2.175v.652a20.726,20.726,0,0,0-2.086-.109c-3.478,0-4.912.848-4.912,3.457,0,2.26.978,3.517,4.825,3.517a10.539,10.539,0,0,0,3.912-.565c.61-.261.783-.478.783-1.239v-5.627C958.92,508.283,957.856,506.37,954.291,506.37Zm2.11,9.346c0,.2-.066.234-.235.3a10.254,10.254,0,0,1-2.173.174c-1.7,0-2.043-.586-2.043-1.456,0-.913.435-1.457,2.087-1.457.848,0,1.935.087,2.369.109Z",
    transform: "translate(-881.076 -502.523)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M380.711,488.983h-3.443l-.321-.492,0,0-3.431-5.266-3.584,5.761h-3.36l5.335-7.868-4.687-6.957,0-.006-.4-.6h3.368l3.487,5.414,3.156-4.867.355-.546h3.268l-5.105,7.543,5.172,7.6Z",
    transform: "translate(-366.57 -473.55)",
    fill: "#f9f9f9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(7.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M109.331,550.9l.028-.028c-1.641,1-4-1.209-4.485-1.865l-.014-.02a.218.218,0,0,0,.151.06.207.207,0,0,0,.149-.062l6.346-6.343,3.048,3.048Z",
    transform: "translate(-98.355 -529.905)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M60.371,479.619l-.028.028h0l-1.572,1.572-.293.293a3.611,3.611,0,0,1-2.571,1.065,3.567,3.567,0,0,1-2.794-1.332l-.023-.029a16.971,16.971,0,0,1-1.655-18.723c1.833-1.627,4.394.737,4.677.96l.014.011a.211.211,0,0,0-.107-.029.218.218,0,0,0-.108.028.215.215,0,0,0-.076.068c-.2.3-.394.613-.572.932a12.669,12.669,0,0,0,.291,12.8l.011.009s.014.029.019.038h0l.009.014v.008c.05.081.1.164.155.243l.084.125a.117.117,0,0,0,.013.016l.016.016.014.02C56.375,478.41,58.735,480.618,60.371,479.619Z",
    transform: "translate(-49.368 -458.653)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M204.528,460.9a.225.225,0,0,0-.162-.072.217.217,0,0,0-.1.026.222.222,0,0,0-.05.037l-7.122,7.113-3.042-3.042,5.654-5.653.008-.008h0c.494-.452,3.088-.8,4.8,1.584Z",
    transform: "translate(-177.089 -456.052)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M92.465,453.092l-.022.021-.018.022a4.1,4.1,0,0,1-3.355,1.849,2.335,2.335,0,0,1-1.512-.431L71.886,438.878l-.02-.011-.028-.035h-.006l-.011-.009-.014-.011c-.284-.223-2.844-2.587-4.677-.96.189-.352.394-.693.611-1.029a16.66,16.66,0,0,1,1.041-1.45l.027-.034A3.569,3.569,0,0,1,71.588,434a3.608,3.608,0,0,1,2.57,1.066L92.172,453.08a.215.215,0,0,0,.152.063A.235.235,0,0,0,92.465,453.092Z",
    transform: "translate(-65.048 -434)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M252.807,445.957a16.9,16.9,0,0,1-2.679,9.151,16.493,16.493,0,0,1-1.041,1.45l-.023.029a3.566,3.566,0,0,1-2.8,1.336,3.61,3.61,0,0,1-2.568-1.064l-2.309-2.308a2.335,2.335,0,0,0,1.512.431,4.087,4.087,0,0,0,3.355-1.846l.018-.022.022-.021h0a.293.293,0,0,0,.036-.043c.059-.088.117-.175.172-.264.043-.066.064-.1.066-.1.117-.193.234-.384.335-.566a12.661,12.661,0,0,0-.57-13.23l-.02-.029h0l-.011-.013c-1.71-2.382-4.3-2.036-4.8-1.584l2.19-2.19a3.611,3.611,0,0,1,2.57-1.071,3.566,3.566,0,0,1,2.791,1.328l.025.031A17.016,17.016,0,0,1,252.807,445.957Z",
    transform: "translate(-218.88 -434)",
    fill: "#f9f9f9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5162",
    "data-name": "Rectangle 5162",
    width: 130,
    height: 24.853,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavXpentraLogo);
export default __webpack_public_path__ + "static/media/NavXpentraLogo.aa5a06d020fa3fa153bb54bf5ea62300.svg";
export { ForwardRef as ReactComponent };